<app-nav [titulo]="broker ? 'Modificar agente ' + broker.nombre + ' ' + broker.apellido : 'Nuevo agente'" [descripcion]="broker ? 'Aquí podrá ver todos los detalles del agente seleccionado y modificarlos.' : 'Por favor complete todos los datos del nuevo agente.'">
    <div class="edit-broker basic-avm-editor">
        <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
            <mat-tab [label]="broker ? 'Edición' : 'Creación manual'">
                <mat-horizontal-stepper class="form-stepper" [linear]="!this.broker" #stepper>
                    <mat-step [stepControl]="generalSectionFG">
                        <form class="form-step" [formGroup]="generalSectionFG" (ngSubmit)="generalSectionFG.valid && stepper.next()">
                            <ng-template matStepLabel>Información general</ng-template>
                            <h3 class="form-step-title">
                                Información general
                            </h3>
                            <span class="form-step-description">
                                Para comenzar complete la información del agente.
                            </span>
                            <div class="form-line">
                                <mat-form-field class="garantor-form-field" appearance="outline">
                                    <mat-label>Nombre</mat-label>
                                    <input matInput formControlName="nombre">
                                    <mat-error *ngIf="generalSectionFG.controls['nombre'].hasError('required')">
                                        Por favor ingrese un nombre
                                    </mat-error>
                                </mat-form-field>
                                <mat-form-field class="garantor-form-field" appearance="outline">
                                    <mat-label>Apellido</mat-label>
                                    <input matInput formControlName="apellido">
                                    <mat-error *ngIf="generalSectionFG.controls['apellido'].hasError('required')">
                                        Por favor ingrese un apellido
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div class="form-line">
                                <mat-form-field class="garantor-form-field" appearance="outline">
                                    <mat-label>Teléfono</mat-label>
                                    <app-phone-input formControlName="celular"></app-phone-input>
                                    <mat-error *ngIf="generalSectionFG.controls['celular'].hasError('required')">
                                        Por favor ingrese un teléfono
                                    </mat-error>
                                    <mat-hint>Ejemplo: + 54 - 911 - 11112222</mat-hint>
                                </mat-form-field>
                                <mat-form-field class="garantor-form-field" appearance="outline">
                                    <mat-label>CUIT/CUIL</mat-label>
                                    <app-cuit-input formControlName="cuit"></app-cuit-input>
                                    <mat-error *ngIf="generalSectionFG.controls['cuit'].hasError('required')">
                                        Por favor ingrese un cuit
                                    </mat-error>
                                    <mat-error *ngIf="generalSectionFG.controls['cuit'].hasError('minlength') || generalSectionFG.controls['cuit'].hasError('maxlength')">
                                        El cuit debe tener 11 dígitos
                                    </mat-error>
                                    <mat-error *ngIf="generalSectionFG.controls['cuit'].hasError('number')">
                                        El cuit debe ser un número
                                    </mat-error>
                                    <mat-hint>Sin guiones, ejemplo: 20123456781</mat-hint>
                                </mat-form-field>
                            </div>
                            <div class="form-step-buttons">
                                <button mat-raised-button color="primary" class="garantor-button">Siguiente</button>
                                <button mat-raised-button color="accent" type="button" class="garantor-button" (click)="createBroker()" *ngIf="broker">Guardar y salir</button>
                            </div>
                        </form>
                    </mat-step>
                    <mat-step [stepControl]="credentialsSectionFG">
                        <form class="form-step" [formGroup]="credentialsSectionFG" (ngSubmit)="credentialsSectionFG.valid && stepper.next()">
                            <ng-template matStepLabel>Credenciales</ng-template>
                            <h3 class="form-step-title">
                                Credenciales
                            </h3>
                            <span class="form-step-description">
                                Complete la información para que el agente pueda ingresar a la plataforma.
                            </span>
                            <mat-form-field class="garantor-form-field" appearance="outline">
                                <mat-label>E-Mail</mat-label>
                                <input matInput formControlName="email">
                                <mat-error *ngIf="credentialsSectionFG.controls['email'].hasError('required')">
                                    Por favor ingrese el email
                                </mat-error>
                                <mat-error *ngIf="credentialsSectionFG.controls['email'].hasError('email')">
                                    Por favor ingrese un email válido
                                </mat-error>
                                <mat-hint>
                                    Este email será utilizado para notificaciones
                                </mat-hint>
                            </mat-form-field>
                            <div class="form-step-buttons">
                                <button mat-button color="primary" type="button" class="garantor-button" matStepperPrevious>Atras</button>
                                <button mat-raised-button color="primary" class="garantor-button">Siguiente</button>
                                <button mat-raised-button color="accent" type="button" class="garantor-button" (click)="createBroker()" *ngIf="broker">Guardar y salir</button>
                            </div>
                        </form>
                    </mat-step>
                    <mat-step>
                        <div class="form-step details-form-step">
                            <ng-template matStepLabel>Resumen</ng-template>
                            <h3 class="form-step-title">
                                Resumen
                            </h3>
                            <span class="form-step-description">
                                Por favor verifique los datos del nuevo agente y presione confirmar.
                            </span>
                            <div class="broker-details-content-container">
                                <app-broker-details-content [broker]="getResultingBroker()"></app-broker-details-content>
                            </div>
                            <div class="form-step-buttons">
                                <button mat-button color="primary" type="button" class="garantor-button" matStepperPrevious>Atras</button>
                                <button mat-raised-button color="accent" type="button" class="garantor-button" (click)="createBroker()">Confirmar</button>
                            </div>
                        </div>
                    </mat-step>
                </mat-horizontal-stepper>
            </mat-tab>
            <mat-tab label="Creación masiva" *ngIf="!broker">
                <app-bulk-creator style="width: 100%;" [columnMaps]="bulkCreatorColumnMaps" [getErrorsFn]="getBulkCreatorErrors" [submitFn]="bulkCreatorSubmit"></app-bulk-creator>
            </mat-tab>
        </mat-tab-group>
    </div>
</app-nav>
